<template>
  <div class="RvbControls">
    <CategoryMenuFilter
      :filter-config="filterConfig"
    />

    <div class="RvbControls__search" />
  </div>
</template>

<script>

import CategoryMenuFilter from '../filters/CategoryMenuFilter.vue'
import TableState from '../mixins/TableState.vue'

/**
 * This component implements the permament controls of the rvb index
 */
export default {
  name: 'RvbControls',
  components: {
    CategoryMenuFilter,
  },
  mixins: [TableState],
  computed: {
    filterConfig() {
      return this.config.filters.category || {}
    },
  },
}
</script>

<style lang="scss">
.RvbControls {
  padding-left: 8px;
}

</style>
